import { Component } from '@angular/core';
import { FiDocumentTemplateItemViewBase } from './document-template-item-view-base';

@Component({
    selector: 'fi-document-template-item-view-simple-text',
    template: `<fi-document-layout-item-simple-text
        [item]="data.item"
        [templateLayoutHelper]="data.templateLayoutHelper"
        [disableEdit]="data.disableEdit"
    >
    </fi-document-layout-item-simple-text>`,
    standalone: false,
})
export class FiDocumentTemplateItemViewSimpleTextComponent extends FiDocumentTemplateItemViewBase {}
